import { createContext, useContext } from "react";

/**
 * When true, AdminPortalShell renders only its children, skipping the
 * outer SidebarProvider/sidebar/header chrome. Used by AdminPipeline
 * (UX-Roles-3B) to embed existing admin pages inside a tabbed shell
 * without nesting a second portal layout.
 */
export const EmbeddedAdminShellContext = createContext(false);

export const useIsEmbeddedAdminShell = () => useContext(EmbeddedAdminShellContext);
